var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacecentered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_535_22276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.7443 6.61758 17.3824 2.25568 12 2.25V2.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.2448 16.5542 16.5542 20.2448 12 20.25V20.25ZM7.5 10.125C7.5 9.50368 8.00368 9 8.625 9C9.24632 9 9.75 9.50368 9.75 10.125C9.75 10.7463 9.24632 11.25 8.625 11.25C8.00368 11.25 7.5 10.7463 7.5 10.125V10.125ZM16.5 10.125C16.5 10.7463 15.9963 11.25 15.375 11.25C14.7537 11.25 14.25 10.7463 14.25 10.125C14.25 9.50368 14.7537 9 15.375 9C15.9963 9 16.5 9.50368 16.5 10.125V10.125ZM16.3997 14.625C15.435 16.2928 13.8309 17.25 12 17.25C10.1691 17.25 8.56594 16.2938 7.60125 14.625C7.45346 14.3925 7.44502 14.0977 7.57928 13.8571C7.71353 13.6166 7.96887 13.469 8.24434 13.4727C8.5198 13.4764 8.77105 13.6309 8.89875 13.875C9.59906 15.0853 10.6997 15.75 12 15.75C13.3003 15.75 14.4009 15.0844 15.1003 13.875C15.3074 13.5162 15.7662 13.3932 16.125 13.6003C16.4838 13.8074 16.6068 14.2662 16.3997 14.625V14.625Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_535_22276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacecentered);
export default __webpack_public_path__ + "static/media/face centered.6c670e055e9ea64a3603339edaa2ef3a.svg";
export { ForwardRef as ReactComponent };